import React, { useEffect, useState } from 'react'
import { colors } from '../constants'
import TableRows from './tableRows'

const TableItem = ({ table, tabName, activeRowCol, claritySort }) => {
  const [activeTable, setActiveTable] = useState(false)

  useEffect(() => {
    if (activeRowCol.min === table[0].min && activeRowCol.max === table[0].max) {
      setActiveTable(true)
    } else {
      setActiveTable(false)
    }
  }, [activeRowCol])

  return (
    <li className='price__tables-item'>
      <p className='price__table-title'>{tabName}, {table[0].min} - {table[0].max} ct</p>
      <div className='price__table-wrap'>
        <table className='price__table'>
          <thead>
            <tr>
              <th className='price__table-header' />
              {claritySort.map((clear) => {
                return <th key={clear} className={`price__table-header ${activeTable && activeRowCol.clarity === clear ? 'price__table-cell--selected' : ''}`}>{clear}</th>
              })}
            </tr>
          </thead>
          <tbody>
            {colors.map((color) => {
              if (table.some(row => row.color === color)) {
                return <TableRows key={color} color={color} table={table} activeRowCol={activeRowCol} activeTable={activeTable} claritySort={claritySort} />
              }
            })}
          </tbody>
        </table>
      </div>
    </li>
  )
}

export default TableItem
